import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: alpha(theme.colors.danger, 0.15),
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    '@media print': {
      display: 'none',
    },
  },
  containerNone: {
    backgroundColor: alpha(theme.colors.white, 0.15),
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 42,
    marginRight: theme.spacing(1),
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
  formControlOverride: {
    marginRight: 0,
    marginLeft: 0,
  },
  checkbox: {
    marginLeft: -7,
    color: theme.palette.text.primary,
  },
  disabled: {
    color: alpha(theme.colors.grey, 0.5),
  },
}));

export default useStyles;
